module.exports = __webpack_public_path__ + "img/solution_technology_04@2x.167f857f.png";